import React from 'react';

/**
 * Intro screen content shown before the conversation starts.
 * Displays Jesse's tagline and action buttons for tips, help, and file upload.
 */
const IntroContent = ({ onShowTips, onShowHelp, onShowUpload }) => {
  return (
    <div className="intro-content-container">
      <div className="intro-description-section">
        <div className="intro-tagline">
          <h2>Jouw persoonlijke vacature assistent</h2>
          <p className="intro-subtitle">Jesse vraagt, adviseert en schrijft</p>
        </div>

        <div className="intro-description">
          <p></p>
        </div>
      </div>

      <div className="intro-help-actions">
        <div className="help-buttons-row">
          <button className="intro-help-btn" onClick={onShowTips}>
            <div className="btn-icon">{'\uD83D\uDCA1'}</div>
            <div className="btn-text">
              <div className="btn-title">Nieuw? Begin hier!</div>
              <div className="btn-subtitle">Bekijk tips voor goede input</div>
            </div>
          </button>

          <button className="intro-help-btn" onClick={onShowHelp}>
            <div className="btn-icon">{'\u2753'}</div>
            <div className="btn-text">
              <div className="btn-title">Hulp nodig?</div>
              <div className="btn-subtitle">Lees hoe het werkt en wat je kunt verwachten</div>
            </div>
          </button>
        </div>

        <div className="help-buttons-row centered">
          <button className="intro-help-btn upload-btn" onClick={onShowUpload}>
            <div className="btn-icon">{'\uD83D\uDCC4'}</div>
            <div className="btn-text">
              <div className="btn-title">Bestaande tekst verbeteren?</div>
              <div className="btn-subtitle">Upload je vacature en laat Jesse helpen</div>
            </div>
          </button>
        </div>
      </div>
    </div>
  );
};

export default IntroContent;
